export default function NotFound() {
  return (
    <div className="container">
      <p>Page not found.</p>
    </div>
  );
}
